<div>
  <div class="row align-items-end">
    <div class="col-12 col-md form-group">
      <app-custom-button
        styleClass="btn-small"
        icon="fas fa-money-check"
        [title]="'creditClaims.createNewClaim' | cxTranslate"
        (click)="onSubmitNewClaimClicked()"
        [showSpinner]="showLoaderWhenNavigate"
        >
      </app-custom-button>
    </div>
    <ng-container>
      <div class="col form-group">
        <app-custom-search-input
          title="Search By"
          placeholder="Search by Claim Number"
          (eventSearch)="onSearch($event)"
        ></app-custom-search-input>
      </div>
      <div class="col col-md-auto form-group">
        <app-custom-select
          [title]="'shared.filterBy' | cxTranslate"
          (changeValue)="filterChange($event)"
          [options]="filterOptions"
          [clearable]="true"
          placeHolder="Status"
        ></app-custom-select>
      </div>
      <div class="col col-md-auto form-group">
        <app-custom-select
          [title]="'shared.sortBy' | cxTranslate"
          (changeValue)="sortChange($event)"
          [clearable]="true"
          [options]="sortOptions"
          [placeHolder]="'shared.select' | cxTranslate"
        ></app-custom-select>
      </div>
    </ng-container>
  </div>
</div>

<!-- rowId="creditClaimCode" -->
@if (creditClaimList?.results?.length) {
  <app-custom-table
    [headers]="headers"
    [columns]="columns"
    rowId="creditClaimCode"
    override="CreditClaimsHistoryRow"
    [rows]="creditClaimList?.results"
    [pagination]="creditClaimList?.pagination"
    (changePagination)="pageChange($event + 1)"
    [showLoader]="showLoaderOnPagination"
  ></app-custom-table>
} @else {
  @if (showMessageWhenNoData) {
    <app-custom-error [errorMessage]="'shared.noClaims' | cxTranslate"></app-custom-error>
  }
}


@if (showLoaderOnStartupOrWhenNoData) {
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
}
